type ReferenceMatchableOption = {
    kind: "reference" | "circuit" | "resolved-default";
    id: number | string;
    label?: string;
    circuit?: { sourceReferenceCircuitId?: number | null };
};

export const findTransportOptionByReferenceId = <T extends ReferenceMatchableOption>(
    options: T[],
    referenceId: number | null | undefined,
): T | null => {
    if (referenceId == null) {
        return null;
    }

    return (
        options.find((option) => {
            if (option.kind === "reference") {
                return option.id === referenceId;
            }

            return option.circuit?.sourceReferenceCircuitId === referenceId;
        }) ?? null
    );
};

export const findTransportOptionForPersistedTransport = <T extends ReferenceMatchableOption>(
    options: T[],
    transportCircuit: { id: number; sourceReferenceCircuitId?: number | null },
): T | null => {
    const byReference = findTransportOptionByReferenceId(options, transportCircuit.sourceReferenceCircuitId);
    if (byReference !== null) {
        return byReference;
    }

    return options.find((option) => option.kind === "circuit" && option.id === transportCircuit.id) ?? null;
};
